import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig } from '../config/authentication'

const pca = new PublicClientApplication(msalConfig)

export const getMsalPca = () => pca
